export default {
  "dashboard.analysis.test": "工專路 {no} 號店",
  "dashboard.analysis.introduce": "指標說明",
  "dashboard.analysis.total-sales": "總銷售額",
  "dashboard.analysis.day-sales": "日銷售額",
  "dashboard.analysis.visits": "訪問量",
  "dashboard.analysis.visits-trend": "訪問量趨勢",
  "dashboard.analysis.visits-ranking": "門店訪問量排名",
  "dashboard.analysis.day-visits": "日訪問量",
  "dashboard.analysis.week": "周同比",
  "dashboard.analysis.day": "日同比",
  "dashboard.analysis.payments": "支付筆數",
  "dashboard.analysis.conversion-rate": "轉化率",
  "dashboard.analysis.operational-effect": "運營活動效果",
  "dashboard.analysis.sales-trend": "銷售趨勢",
  "dashboard.analysis.sales-ranking": "門店銷售額排名",
  "dashboard.analysis.all-year": "全年",
  "dashboard.analysis.all-month": "本月",
  "dashboard.analysis.all-week": "本周",
  "dashboard.analysis.all-day": "今日",
  "dashboard.analysis.search-users": "搜索用戶數",
  "dashboard.analysis.per-capita-search": "人均搜索次數",
  "dashboard.analysis.online-top-search": "線上熱門搜索",
  "dashboard.analysis.the-proportion-of-sales": "銷售額類別占比",
  "dashboard.channel.all": "全部渠道",
  "dashboard.channel.online": "線上",
  "dashboard.channel.stores": "門店",
  "dashboard.analysis.sales": "銷售額",
  "dashboard.analysis.traffic": "客流量",
  "dashboard.table.rank": "排名",
  "dashboard.table.search-keyword": "搜索關鍵詞",
  "dashboard.table.users": "用戶數",
  "dashboard.table.weekly-range": "周漲幅",
};
